import {
    Form,
    Input,
    Button,
    Switch,
    Col,
    Row,
    Space,
    DatePicker,
    Select,
    type DatePickerProps,
} from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import commonStyles from '../../../../../../Utils/Common.less'
import { GetCountryList } from '../../../../../../Services/Common'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import { type TogilleAddress } from '../../../../../../Types/Client/RegisteredClients/Corporate'
import dayjs from 'dayjs'
import moment from 'moment'
import ActivePremission from '../../../../../../Utils/premissins'
import { PermissionType } from '../../../../../../Types/Enum/PermissionType'
import { GetAddress, SavePartner } from '../../../../../../Services/Parnership'
import { validateDate } from '../../../../../../Utils/ValidateDate'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { validateName } from '../../../../../../Utils/Common'
import InputFieldNINumber from '../../../../../../Components/InputNINO'

interface editPage {
    editData: any
    countryList: ListFrontEndInterface[]
    corporateId: number
    saveCallBack: CallableFunction
    ReFetchData: () => void
    activeTab: string
}
interface EditDataState {
    countryList: ListFrontEndInterface[]
}
const PartnerMemberEditForm = (props: editPage): React.ReactElement => {
    const {
        editData,
        countryList,
        corporateId,
        saveCallBack,
        ReFetchData,
        activeTab,
    } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [switchStates, setSwitchStates] = useState<{
        2: boolean
        3: boolean
    }>({
        2: false,
        3: false,
    })
    const [addressDatas, setAddressData] = useState<TogilleAddress | null>(null)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                partnerAddressOne: address.line_1,
                partnerAddressTwo: address.line_2,
                partnerTown: address.post_town,
                partnerCountry: countryData?.label ?? '',
                partnerPostCode: address.postcode,
            }

            form.setFieldsValue(AddressData)
        }
    }, [address])
    useEffect(() => {
        const newSwitchStates = {
            2: false,
            3: false,
        }
        setSwitchStates(newSwitchStates)
        form.resetFields()
    }, [activeTab])
    useEffect(() => {
        form.setFieldValue('referenceId', '0')
        GetCountryList(dispatch)
    }, [dispatch])

    useEffect(() => {
        if (countryList !== null && editData !== null) {
            const countryData = countryList?.find(
                (data: ListFrontEndInterface) => data.label === editData.country
            )
            const newData = {
                ...editData,
                country: countryData?.label ?? 'Please Select',
            }
            form.setFieldsValue(newData)
        }
    }, [editData, countryList])

    useEffect(() => {
        if (editData !== null) {
            const dateOfBirth = moment(
                editData.dateOfBirth,
                'M/D/YYYY h:mm:ss A'
            )
            const formattedDate = dateOfBirth.format('MM/DD/YYYY HH:mm:ss A')
            setSelectedDate(formattedDate)
        }
    }, [editData])

    useEffect(() => {
        form.setFieldValue('dateOfBirth', selectedDate)
    }, [selectedDate])

    const onChange = (
        dateOfBirth: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }

    const handleSwitchChange = (switchId: 2 | 3): void => {
        const newSwitchStates = {
            2: false,
            3: false,
        }
        if (!switchStates[switchId]) {
            newSwitchStates[switchId] = true
            void GetAddress(
                dispatch,
                corporateId,
                switchId,
                (addressData: TogilleAddress) => {
                    setAddressData(addressData)
                }
            )
        }
        setSwitchStates(newSwitchStates)
    }

    useEffect(() => {
        if (addressDatas !== null && typeof addressDatas === 'object') {
            const newFieldValues = {
                partnerAddressOne: addressDatas?.addressLineOne,
                partnerAddressTwo: addressDatas?.addressLineTwo,
                partnerTown: addressDatas?.town,
                partnerCountry: addressDatas?.country,
                partnerPostCode: addressDatas?.postCode,
            }

            form.setFieldsValue(newFieldValues)
        }
    }, [addressDatas])

    const onPresonEditData = (): void => {
        void onSaveData()
    }

    const onSaveData = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            const formdata = form.getFieldsValue()
            const dataToSave = {
                partnerId: editData.partnerId,
                partnershipId: editData.partnershipId,
                individualId: editData.individualId,
                tagIndividualId: editData.tagIndividualId,
                individualClientNumber: editData.individualClientNumber,
                title: formdata.title ?? '',
                firstName: formdata.firstName,
                middleName: formdata.middleName ?? '',
                surName: formdata.surName,
                dateOfBirth:
                    moment(formdata.dateOfBirth).format('DD/MM/YYYY') ===
                    'Invalid date'
                        ? ''
                        : moment(formdata.dateOfBirth).format('DD/MM/YYYY'),
                partnerAddressOne: formdata.partnerAddressOne,
                partnerAddressTwo: formdata.partnerAddressTwo ?? '',
                partnerTown: formdata.partnerTown,
                partnerCountry: formdata.partnerCountry ?? '',
                partnerPostCode: formdata.partnerPostCode,
                mobileNumber: formdata.mobileNumber,
                homeNumber: formdata.homeNumber ?? '',
                workNumber: formdata.workNumber ?? '',
                emailAddress: formdata.emailAddress,
                alternativeEmailAddress: formdata.alternativeEmailAddress ?? '',
                individualUTR: formdata.individualUTR ?? '',
                niNumber: formdata.niNumber ?? '',
                isActive: 'Active',
                isDelete: 'Inactive',
            }

            await SavePartner(dispatch, dataToSave).then((result) => {
                if (result !== null && result !== undefined) {
                    saveCallBack(dataToSave)
                    ReFetchData()
                    form.resetFields()
                    setButtonLoading(false)
                    window.scroll(0, 0)
                }
            })
        } catch (error) {}
    }
    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
    }
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                name="complex-1"
                initialValues={{ remember: true }}
                {...formItemLayout}
                autoComplete="off"
                form={form}
                layout="vertical"
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item label="Same as Business">
                            <Switch
                                id="2"
                                checked={switchStates[2]}
                                onChange={() => {
                                    handleSwitchChange(2)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Same as Correspondence">
                            <Switch
                                id="3"
                                checked={switchStates[3]}
                                onChange={() => {
                                    handleSwitchChange(3)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item
                            label="First Name"
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your First Name!',
                                },
                                {
                                    pattern: /^[A-Za-z]+$/,
                                    message:
                                        'First Name can only contain letters!',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Date of Birth"
                            name="dateOfBirth"
                            rules={[
                                {
                                    validator: async (_, value) =>
                                        await validateDate(value),
                                },
                            ]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    allowClear
                                    onChange={onChange}
                                    value={
                                        selectedDate.length > 0
                                            ? dayjs(selectedDate)
                                            : null
                                    }
                                    format="DD/MM/YYYY"
                                    className={commonStyles.dateWidth}
                                    disabledDate={(current) =>
                                        current !== null &&
                                        current > dayjs().endOf('day')
                                    }
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item
                            label="Middle Name"
                            name="middleName"
                            rules={[
                                {
                                    validator: async (rule, value) =>
                                        await validateName(
                                            rule,
                                            value,
                                            'Middle Name'
                                        ),
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Mobile Number"
                            name="mobileNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Mobile number Should be 10-15 digit',
                                },
                                {
                                    required: true,
                                    message: 'Please input your mobile number!',
                                },
                            ]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item
                            label="Surname"
                            name="surName"
                            rules={[
                                {
                                    validator: async (rule, value) =>
                                        await validateName(
                                            rule,
                                            value,
                                            'Surname'
                                        ),
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Home Number"
                            name="homeNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Home Number  Should be 10-15 digit',
                                },
                            ]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item
                            label="Address 1"
                            name="partnerAddressOne"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Address 1',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Work Number"
                            name="workNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        ' Work Number Should be 10-15 digit ',
                                },
                            ]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item label="Address 2" name="partnerAddressTwo">
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email Address"
                            name="emailAddress"
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'Please input your email!',
                                },
                            ]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item
                            label="Town"
                            name="partnerTown"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Town!',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={50} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Alternative Email Address"
                            name="alternativeEmailAddress"
                            rules={[
                                {
                                    type: 'email',
                                    message:
                                        'Please input your Alternative Email Address!',
                                },
                            ]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <Form.Item label="Country" name="partnerCountry">
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={() => {}}
                                options={countryList?.map((country) => ({
                                    value: country.label,
                                    label: country.label,
                                }))}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.label
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase()) ?? false
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        {/* <Form.Item label="NI Number" name="niNumber">
                            <Input allowClear maxLength={9} />
                        </Form.Item> */}
                        <InputFieldNINumber name="niNumber" form={form} />
                    </Col>
                </Row>

                <Row gutter={16} className={commonStyles.margin_Top20}>
                    <Col span={12}>
                        <PostCodeInput
                            name="partnerPostCode"
                            label="Post Code"
                            reuireMessage="Please Enter Post Code"
                            placeHolder={''}
                            setAddressDetails={setAddress}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Individual UTR" name="individualUTR">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                {ActivePremission('3000', PermissionType.SAVE) && (
                    <Row gutter={16} className={commonStyles.margin_Top20}>
                        <Col offset={21} span={2}>
                            <Button
                                type="primary"
                                onClick={onPresonEditData}
                                loading={buttonLoading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Col>
                    </Row>
                )}
            </Form>
        </div>
    )
}
const mapStateToProps = (state: any): EditDataState => {
    return {
        countryList: state.common.countryList,
    }
}
export default connect(mapStateToProps)(PartnerMemberEditForm)
